<template>
    <!-- Feature section -->
    <section class="theme-bg feature" id="feature">
        <div class="container">
            <div class="animation-circle-inverse">
                <i></i>
                <i></i>
                <i></i>
            </div>
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="section-title">
                        <h2 class="text-white"> ميزة حلقة الدردشة</h2>
                        <img src="../../assets/images/white-line.png" alt="white-line" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6">
                    <div class="future-box">
                        <div class="future-timeline">
                            <ul>
                                <li class="timeline">
                                    <h4 class="sub-title">سهل التركيب</h4>
                                    <p class="">كان أبجد هوز في الصناعة</p>
                                </li>
                                <li class="timeline">
                                    <h4 class="sub-title">موضوع منصة الدردشة التطبيق</h4>
                                    <p class="">كان أبجد هوز في الصناعة</p>
                                </li>
                                <li class="timeline">
                                    <h4 class="sub-title"> تأمين النسخ الاحتياطي والاسترداد</h4>
                                    <p class="">العديد من حزم النشر المكتبي</p>
                                </li>
                                <li class="timeline">
                                    <h4 class="sub-title">من السهل مشاركة الملفات</h4>
                                    <p class="">كان أبجد هوز في الصناعة</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 future-mobile">
                    <img src="../../assets/images/feature-mob.png" alt="feature-mob" class="img-fluid">
                </div>
                <div class="col-lg-4 col-sm-6">
                    <div class="future-box">
                        <div class="future-timeline-right">
                            <ul class="text-left">
                                <li class="timeline-right">
                                    <h4>سهل التركيب</h4>
                                    <p class="">كان أبجد هوز في الصناعة</p>
                                </li>
                                <li class="timeline-right">
                                    <h4>موضوع منصة الدردشة التطبيق</h4>
                                    <p class="">كان أبجد هوز في الصناعة</p>
                                </li>
                                <li class="timeline-right">
                                    <h4>آمن النسخ الاحتياطي والاسترداد</h4>
                                    <p class="">Many desktop publishing packages</p>
                                </li>
                                <li class="timeline-right">
                                    <h4>من السهل مشاركة الملفات</h4>
                                    <p class="">كان أبجد هوز في الصناعة</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- end Feature section -->
</template>
<script>
export default {
  name: 'Feature'
}
</script>
